import * as React from "react"
import {Route, Routes} from "react-router-dom";

import MemberPage from "./member/MemberPage";
import {ROUTES} from "../helpers/constants";
import LibraryPage from "./eLibrary/LibraryPage";
import DownloadsPage from "./downloads/DownloadsPage";
import LoginPage from "./login/LoginPage";
import RequireAuth from "./login/RequireAuth";
import UnsubscribePage from "./unsubscribe/UnsubscribePage";

const Content = () => {

  return (
    <Routes>
      <Route path={ROUTES.home} element={<RequireAuth><MemberPage/></RequireAuth>}  />
      <Route path={ROUTES.eLibrary} element={<RequireAuth><LibraryPage/></RequireAuth>}  />
      <Route path={ROUTES.downloads} element={<RequireAuth><DownloadsPage/></RequireAuth>}  />
      <Route path={ROUTES.login} element={<LoginPage/>} />
      <Route path={ROUTES.restore} element={<LoginPage/>} />
      <Route path={ROUTES.unsubscribe} element={<UnsubscribePage/>} />
      <Route path={ROUTES.unsubscribeSuccess} element={<UnsubscribePage/>} />
    </Routes>
  )
}

export default Content
